import DOMPurify from 'dompurify'
import { LoaderCircleIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { Quill } from 'react-quill-new'

import { RichTextEditor } from '@/components/shared/rich-text-editor/rich-text-editor'

import { ASSESSMENT_REPORT_LAYOUT_LABELS } from './labels'

export type AssessmentReportLayoutProps = {
  header: ReactNode
  footer?: ReactNode
  isReportLoading: boolean
  isEditing?: boolean
  reportContent: string
  onQuillReady: (quill: Quill) => void
}

export const AssessmentReportLayout = ({
  header,
  footer,
  isReportLoading,
  isEditing = false,
  reportContent,
  onQuillReady,
}: AssessmentReportLayoutProps) => (
  <div className='mb-6 flex min-h-0 flex-1 flex-col rounded border bg-main-background-card py-8 pl-10'>
    {header}
    <div className='flex min-h-0 w-full flex-1 flex-col gap-4 overflow-y-auto pt-4'>
      {isReportLoading ? (
        <div className='flex flex-1 flex-col items-center justify-center gap-1'>
          <LoaderCircleIcon className='size-12 animate-spin text-main-foreground-tertiary' />
          <p className='text-main-foreground-secondary text-label-default'>
            {ASSESSMENT_REPORT_LAYOUT_LABELS.GENERATING_SUMMARY_TITLE}
          </p>
        </div>
      ) : isEditing ? (
        <div className='min-h-60 flex-1 bg-main-background-card pr-10'>
          <RichTextEditor text={reportContent} onQuillReady={onQuillReady} />
        </div>
      ) : (
        <div
          className='prose w-full'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(reportContent) }}
        />
      )}
    </div>
    {footer}
  </div>
)
